import { Divider, Input, Rate, Form, Button } from "antd";
import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { MainStore } from "core/store";
import dayjs from "dayjs";
import { ExclamationOutlined } from "@ant-design/icons";
import api from "api";
import "./style.css";
import Loading from "components/loading";

export default function Review() {
  const { userData } = useContext(MainStore);
  const [isLoading, setIsLoading] = useState(false);
  const [reviewData, setReviewData] = useState(null);

  const [rateValue, setRateValue] = useState(0);

  const [isBlockReview, setIsBlockReview] = useState(false);

  const params = useParams();
  const formRef = useRef();

  useEffect(() => {
    onGetReviewData();
  }, []);

  async function onGetReviewData() {
    setIsLoading(true);
    try {
      const { data } = await api.reviewApi.getReviewById(
        params.id,
        userData.id
      );
      const info = data.data;
      setReviewData(info);
      checkHourGap(info.tf_date);

      if (info.is_review) {
        setRateValue(info.review_rate);
        formRef?.current?.setFieldsValue({
          rate: info.review_rate,
          comment: info.review_comment,
        });
      }
    } catch (error) {
      console.error("onGetReviewData", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function handleSubmitReview(values) {
    setIsLoading(true);
    const params = {
      ...values,
      caddy_id: reviewData.caddy_id,
      golfer_id: reviewData.golfer_id,
      job_id: reviewData.id,
    };
    try {
      await api.reviewApi.createReview(params);
      onGetReviewData();
    } catch (error) {
      console.log("handleSubmitReview", error);
    } finally {
      setIsLoading(false);
    }
  }

  const checkHourGap = (dateString) => {
    const inputDate = dayjs(dateString);
    const currentDate = dayjs();

    const hourDifference = currentDate.diff(inputDate, "hour");

    if (hourDifference > 48) {
      setIsBlockReview(true);
    }
  };

  return (
    <div className="search-caddy-container">
      <Loading visible={isLoading} />
      <div
        style={{
          padding: 25,
          fontWeight: "bold",
          fontSize: 24,
          position: "sticky",
          top: 0,
          left: 0,
          zIndex: 9,
          background: "white",
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          borderBottomRightRadius: 30,
          borderBottomLeftRadius: 30,
        }}
      >
        <center>ให้คะแนนแคดดี้</center>
      </div>
      <div
        className="search-caddy-content"
        style={{ padding: 0, marginTop: -10 }}
      >
        <div
          style={{
            padding: "0px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 10,
            alignItems: "center",
          }}
        >
          <Divider style={{ margin: "10px 0px" }} />
          <div
            style={{
              padding: "20px 25px 0px 25px",
              backgroundColor: "white",
              borderRadius: 20,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 10,
              alignItems: "center",
            }}
          >
            <div
              style={{
                borderRadius: "50%",
                border: "2px solid black",
                width: 180,
                height: 180,
                backgroundImage: `url(${reviewData?.image_lists[0].image_url})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            />
            <h2 style={{ marginBottom: 0 }}>
              {reviewData?.caddy_name} (เบอร์: {reviewData?.caddy_number})
            </h2>
            <div style={{ color: "rgb(105 105 105)" }}>
              {reviewData?.data?.caddy?.about_me}
            </div>
            <div style={{ color: "#007AFF" }}>
              {reviewData?.data?.golfcourse?.name}
            </div>
            <Divider style={{ margin: "10px 0px" }} />
            {console.log("reviewData", reviewData)}
            {isBlockReview ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 15,
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "30px 0px",
                }}
              >
                <ExclamationOutlined style={{ color: "red", fontSize: 52 }} />
                <p style={{ fontSize: 18, textAlign: "center" }}>
                  <div>รีวิวนี้หมดอายุแล้ว</div>
                  <div>({reviewData?.booking_ref})</div>
                </p>
              </div>
            ) : (
              <Form
                ref={formRef}
                onFinish={handleSubmitReview}
                style={{ width: "100%" }}
              >
                <Form.Item
                  style={{ textAlign: "center", marginTop: -10 }}
                  name="rate"
                  label="คะแนนแคดดี้"
                  rules={[{ required: true, message: "กรุณาให้คะแนนแคดดี้" }]}
                >
                  <Rate
                    disabled={reviewData?.is_review}
                    style={{ fontSize: 36 }}
                    onChange={(e) => setRateValue(e)}
                    stle={{ fontSize: 32, width: "100%" }}
                    allowHalf
                  />
                </Form.Item>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 10,
                    marginTop: -20,
                  }}
                >
                  <div>{rateValue} คะแนน</div>
                </div>
                <Form.Item name="comment" label="คอมเมนต์">
                  <Input.TextArea
                    disabled={reviewData?.is_review}
                    style={{
                      border: "1px solid rgba(5, 5, 5, 0.06)",
                      borderRadius: 15,
                    }}
                  />
                </Form.Item>
                <div style={{ marginTop: -15, marginBottom: 10 }}>
                  <div>
                    {" "}
                    วันที่ทีออฟ (Tee-Off) :{" "}
                    {dayjs(reviewData?.tf_date).format("DD-MM-YYYY")}
                  </div>
                  <div>
                    {" "}
                    เวลาทีออฟ (Tee-Off) :{" "}
                    {dayjs(reviewData?.tf_time).format("HH:mm")}
                  </div>
                  <div>
                    {" "}
                    ทิป :{" "}
                    {new Intl.NumberFormat().format(
                      reviewData?.grand_total
                    )}{" "}
                    บาท
                  </div>
                </div>
                {!reviewData?.is_review && (
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      style={{ width: "100%" }}
                      type="primary"
                    >
                      รีวิว
                    </Button>
                  </Form.Item>
                )}
              </Form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
